import { BKJListItem, BKJSelect, ErrorBoundary } from '@bookjane2/bookjane-design-library';
import { IBKJSelectRenderOptionsProps } from '@bookjane2/bookjane-design-library/lib/components/BKJSelect/BKJSelect.types';
import { PayCodeSelectInputProps } from 'components/PayCodeSelectInput/PayCodeSelectInput.types';
import { FC, Fragment } from 'react';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

export const PayCodeSelectInput = ({
  name,
  value,
  onChange,
  options,
  label,
  placeholder,
  required,
}: PayCodeSelectInputProps) => {
  const RenderOptions: FC<IBKJSelectRenderOptionsProps> = (props) => (
    <Fragment>
      {options.map((option) => {
        const { type, optionIdsByValue, ...restProps } = props;
        return (
          <BKJListItem
            {...restProps}
            key={option.key}
            id={optionIdsByValue?.get(option.value)}
            name={name}
            value={option.value}
            label={option.label}
          />
        );
      })}
    </Fragment>
  );

  return (
    <ErrorBoundary
      componentName="PayCodeSelectInput"
      showLogo={!WhiteLabelAccessor.isWhiteLabelled()}
    >
      <BKJSelect
        options={options}
        type="Single"
        variant="GreyOutlined"
        dropdownPlacement="bottom-start"
        name={name}
        value={value}
        onChange={onChange}
        label={label}
        placeholder={placeholder}
        required={required}
        renderOptions={RenderOptions}
      />
    </ErrorBoundary>
  );
};
